import React, { ReactNode, RefObject, SyntheticEvent } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
  borderRadius,
  mediaMaxWithLayoutTheme,
} from 'presentations/views/styles';
import { black, white } from 'presentations/views/styles/color';
import Icon from 'presentations/views/components/atoms/Icon';

interface Props {
  color: string;
  isChecked?: boolean;
  onChange?: (e: SyntheticEvent<HTMLButtonElement>) => void;
  isLightColor?: boolean;
  isDisabled?: boolean;
  className?: string;
}

export default function ChipTextField(props: Props) {
  return (
    <ColorButton
      className={props.className}
      color={props.color}
      onClick={props.onChange}
      value={props.color}
      name="color"
      disabled={props.isDisabled}
      isDisabled={props.isDisabled}
    >
      {props.isChecked && (
        <ColorCheckIcon
          name="check"
          color="inherit"
          isLightColor={props.isLightColor}
        />
      )}
    </ColorButton>
  );
}

const ColorButton = styled.button<{ isDisabled?: boolean }>`
  cursor: ${(props) => (props.isDisabled ? 'normal' : 'pointer')};
  display: flex;
  align-items: center;
  padding: 0;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: ${borderRadius(4)};
  background-color: ${({ color }) => color};

  ${(props) => mediaMaxWithLayoutTheme(props, 'tablet')} {
    width: 28px;
    height: 28px;
  }
`;
const ColorCheckIcon = styled(Icon)<{
  isLightColor?: boolean;
}>`
  width: 24px !important;
  height: 24px !important;
  fill: ${({ isLightColor }) => (isLightColor ? black : white)};

  ${(props) => mediaMaxWithLayoutTheme(props, 'tablet')} {
    width: 20px !important;
    height: 20px !important;
  }
`;
